/**
 * file : MyPage/Index.jsx
 * 설명 : 마이 페이지 메인 화면
 */

import my_img1 from "assets/images/my_img1.png"
import my_img2 from "assets/images/my_img2.png"
import my_img3 from "assets/images/my_img3.png"
import my_img4 from "assets/images/my_img4.png"
import my_img5 from "assets/images/my_img5.png"
import my_img6 from "assets/images/my_img6.png"
import my_img7 from "assets/images/my_img7.png"

import Info from "./Info";
import { Fnc, Url } from "common/globals";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Search } from "components/Common/ApiCall";
import { Spinner } from "components/Common/Componentization"

export default function Index() {
  document.title = '마이 페이지'
  // 경로 지정 
  const navigate = useNavigate();
  // 데이터
  const [datas, setDatas] = useState();
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);
  useEffect(() => {
    Search('/my-info', setDatas, setDataLoading);
  }, [])
  
  return(
    <>
      <Spinner show={dataLoading} />
      <div className="mypage_wrap">
        <div className="location">
          MY PAGE &nbsp; &gt; &nbsp; 나의 정보 &nbsp;
        </div>
        <Info />
        <div className="tab_mu">
          <div className="tab box_style1">
            <ul>
              <li onClick={() => navigate("/myPage/tournamentRequest")}>
                토너먼트 신청내역
              </li>
              <li onClick={() => navigate("/myPage/Message")}>
                쪽지함
              </li>
              <li onClick={() => navigate("/myPage/inquery")}>
                문의하기
              </li>
            </ul>
          </div>
        </div>          
        <div className="my_page_infor">
          <div className="box">
            <div className="inner_box man">
              <h2 className="font_style1">Unique number</h2>
              <p>고유번호</p>
              <span><img src={my_img1} alt="img" /></span>
              <div>
                <input type="text" value={(!Fnc.Empty(datas)) ? datas.idx : ''} className="color-white" readOnly/>
              </div>
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">Site Address</h2>
              <p>소속 사이트 주소</p>
              <span><img src={my_img3} alt="img" /></span>
              <div><span>{(!Fnc.Empty(datas)) ? datas.domain : ''}</span></div>
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">ID</h2>
              <p>소속 사이트 아이디</p>
              <span><img src={my_img4} alt="img" /></span>
              <div><span>{(!Fnc.Empty(datas)) ? datas.site_id : ''}</span></div>
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">Situation</h2>
              <p>상태</p>
              <span><img src={my_img5} alt="img" /></span>
              <div><span>{(!Fnc.Empty(datas)) ? (datas.state_name) : ''}</span></div>
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">Recent Tournament</h2>
              <p>최근 토너먼트</p>
              {
                !Fnc.Empty(datas) && <>
                  {!Fnc.Empty(datas.recently_tournament) && <span className="tmt_img"><img src={Url.TournamentImgUrl + datas.recently_tournament.img} alt="img" /></span>}
                  <div>{!Fnc.Empty(datas.recently_tournament) ? datas.recently_tournament.name : '-'}</div> 
                </>
              }
            </div>
          </div>
          <div className="box">
            <div className="inner_box man">
              <h2 className="font_style1">Tournaments</h2>
              <p>참여 토너먼트</p>
              <span><img src={my_img2} alt="img" /></span>
              {
                !Fnc.Empty(datas) && <div>
                  {!Fnc.Empty(datas.recently_tournament) ? datas.recently_tournament.name : '-'}
                  <br />
                  { 
                    datas.tournament_cnt > 0 && <>토너먼트 외 <b className="txt_org">{(Number(datas.tournament_cnt) - 1).toLocaleString()} 개</b></>
                  }
                </div>
              }
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">Money</h2>
              <p>누적 상금</p>
              <span><img src={my_img6} alt="img" /></span>
              { !Fnc.Empty(datas) && <div><p><span className="won"></span>{datas.settlement_amount.toLocaleString()}</p></div>}
            </div>
          </div>
          <div className="box">
            <div className="inner_box">
              <h2 className="font_style1">Top Prize</h2>
              <p>최고 상금</p>
              <span><img src={my_img7} alt="img" /></span>
              { !Fnc.Empty(datas) && <div>{!Fnc.Empty(datas.best_prize_tournament) ? datas.best_prize_tournament : '-'}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}